import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[b2cAccordionContent]',
})
export class AccordionContentDirective {
  templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}
